import type { Point } from 'geojson'
import { useCallback, useContext } from 'react'
import { MapContext } from '../../../Map/MapContext/MapContext'
import { serviceCenterStore } from '../../store/serviceCenterStore'
import { TNodeStatus } from '../../types'
import { transformCoordsToLatLng } from './transformCoordsToLatLng'

export const useNodeSelect = () => {
  const { map } = useContext(MapContext)

  const selectNode = useCallback(
    (nodeId: string, nodeStatus: TNodeStatus, coords: Point) => {
      const selectedEquipmentId = serviceCenterStore.selectors.getSelectedEquipmentId(
        serviceCenterStore.getState(),
      )

      if (selectedEquipmentId === nodeId) {
        // Unselect the node if already selected
        serviceCenterStore.actions.selectEquipment(
          null,
          nodeStatus === TNodeStatus.PLANNED ? 'planned' : 'active',
        )

        return
      }

      const clickedNodeCoords = transformCoordsToLatLng(coords)
      const zoomLevel = map?.getZoom()

      let latAdjustment

      if (zoomLevel && zoomLevel > 17) {
        latAdjustment = 0.0001
      } else if (zoomLevel && zoomLevel > 16) {
        latAdjustment = 0.001
      } else {
        latAdjustment = 0.003
      }

      // set map center slightly below the clicked node to give space for the selected equipment card
      map?.panTo({ ...clickedNodeCoords, lat: clickedNodeCoords.lat - latAdjustment })

      const listener = map?.addListener('idle', () => {
        // set selected equipment after the map has finished panning
        serviceCenterStore.actions.selectEquipment(
          nodeId,
          nodeStatus === TNodeStatus.PLANNED ? 'planned' : 'active',
        )

        listener?.remove()
      })
    },
    [map],
  )

  return { selectNode }
}
